import React, { useState, useEffect } from 'react';
import axios from 'axios';

const WidgetCategoryList = (props) => {
  //console.log(props);
  const [categoryList, setCategoryList] = useState();
  //   const _getCategory = async () => {
  //     const result = await axios.get(
  //       'http://son.aniplustv.com:3070/api/getCategory'
  //     );
  //     const intReturn = result.data.intReturn;
  //     if (intReturn === 0) {
  //       setCategoryList(result.data.listData);
  //     }
  //   };
  const _itemClick = (title, intent) => {
    //console.log(intent);
    if (intent) {
      props.actionProvider._categorySubSelect(intent);
    } else {
      props.actionProvider._categorySubSelect(title);
    }
  };
  const _goHome = () => {
    props.actionProvider._home(-1);
  };
  useEffect(() => {
    setCategoryList(props.payload.list);
  }, [props]);
  return (
    <>
      <div className="widget-container">
        {/* <div className="">
          <div className="widget-title">아래의 내용을 찾으셨나요?</div>
        </div> */}

        <ul className="widget-content">
          {categoryList &&
            categoryList.map((item) => (
              <li
                key={item.idx}
                onClick={() => _itemClick(item.title, item.intentName)}
              >
                {item.title}
              </li>
            ))}
          <li onClick={_goHome}>
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </li>
        </ul>
      </div>
      {/* <div className="widget-time">{props.payload.writetime}</div> */}
    </>
  );
};
export default WidgetCategoryList;
